/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbHeader, AbHeaderContextProvider } from "abreact/misc/AbHeader";
import { AbSize } from "abreact/misc/AbSize";
import { AbIcon } from "absdk/commons/ui/misc/AbIcon";
import * as React from "react";
/**
 * A visual component to communicate different page status. 
 * 
 * For HTTP related errors, such as "404 Page Not Found", "Service Unavailable", etc,
 * consider using AbHttpErrorPage.
 */
export function AbPageStatusDisplay(props) {
  return /*#__PURE__*/React.createElement("div", ReactUtils.componentProps("ab-page-status-display", props), /*#__PURE__*/React.createElement("div", {
    className: "ab-page-status-display-content"
  }, props.icon && /*#__PURE__*/React.createElement(AbIcon, {
    className: "ab-page-status-display-icon",
    image: props.icon,
    size: AbSize.CUSTOM
  }), /*#__PURE__*/React.createElement(AbHeader, {
    className: ReactUtils.classNamesString(["ab-page-status-display-title", "ab-font-heading-2xlarge"])
  }, props.title), /*#__PURE__*/React.createElement(AbHeaderContextProvider, null, /*#__PURE__*/React.createElement("div", {
    className: "ab-page-status-display-message"
  }, props.message), props.body)));
}
//# sourceMappingURL=AbPageStatusDisplay.js.map
